import { render } from "./ComissaoTable.vue?vue&type=template&id=30e7e890"
import script from "./ComissaoTable.vue?vue&type=script&lang=js"
export * from "./ComissaoTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__